// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   SOCIAL INPUT
   ============================================================================= */

   .SocialInput-module__container__RXG8k {
    width: 100%;
  }

  .SocialInput-module__wrapper__zJIHW {
    display: flex;
    align-items: stretch;
    width: 100%;
    border-radius: var(--mantine-radius-default);
    flex-wrap: nowrap;
  }

  .SocialInput-module__wrapperStacked__EofyF {
    flex-direction: column;
    height: auto;
  }

  /* .wrapper--error .prefix */
  .SocialInput-module__wrapperError__eHYQU .SocialInput-module__prefix__VxDEj {
    border-color: var(--mantine-color-red-6);
  }

  /* Keep prefix border in sync with the input focus state.
     &:focus-within:not(.wrapper--error) .prefix */
  .SocialInput-module__wrapper__zJIHW:focus-within:not(.SocialInput-module__wrapperError__eHYQU) .SocialInput-module__prefix__VxDEj {
    border-color: var(--mantine-color-dark-6);
  }

  .SocialInput-module__prefix__VxDEj {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 12px;
    background-color: var(--mantine-color-gray-0);
    border: 1px solid var(--mantine-color-gray-4);
    border-right: none;
    border-top-left-radius: var(--mantine-radius-default);
    border-bottom-left-radius: var(--mantine-radius-default);
    white-space: nowrap;
    /* No height here: \`align-items: stretch\` on the wrapper only applies to an
       item whose cross size is \`auto\`, so declaring one would opt the prefix
       out of stretching and leave it at content height beside a taller field. */
    transition: border-color 120ms ease;
  }

  .SocialInput-module__prefixStacked__v8sie {
    width: 100%;
    min-height: 36px;
    border-right: 1px solid var(--mantine-color-gray-4);
    border-bottom: none;
    border-top-right-radius: var(--mantine-radius-default);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  /* [data-mantine-color-scheme="dark"] & */
  [data-mantine-color-scheme="dark"] .SocialInput-module__prefix__VxDEj {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
  }

  /* The prefix is a Box of its own, so it inherits nothing from the disabled
     input beside it: same token, opacity and cursor Mantine gives its inputs.
     Declared after the dark-scheme rule above, which has equal specificity and
     would otherwise win on the background. No colour: the icon and the prefix
     text set their own, so it would never be inherited. No border-color: the
     opacity already fades the border like the input's, and it would collide
     with \`.wrapperError .prefix\` at the same specificity. */
  .SocialInput-module__wrapperDisabled__l5WHj .SocialInput-module__prefix__VxDEj {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: var(--mantine-color-disabled);
  }

  .SocialInput-module__icon__UlFkr {
    flex-shrink: 0;
    color: var(--mantine-color-gray-6);
  }

  .SocialInput-module__icon__UlFkr[data-social-image-icon='true'] {
    opacity: 0.62;
  }

  [data-mantine-color-scheme="dark"] .SocialInput-module__icon__UlFkr {
    color: var(--mantine-color-gray-5);
  }

  [data-mantine-color-scheme="dark"] .SocialInput-module__icon__UlFkr[data-social-image-icon='true'] {
    opacity: 0.8;
  }

  .SocialInput-module__prefixText__pZ467 {
    font-family: var(--mantine-font-family-monospace);
    font-size: 0.813rem;
    user-select: none;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .SocialInput-module__field__Lv0Qi {
    flex: 1;
    display: flex;
    width: 100%;
    min-width: 0; /* Allow flex item to shrink below content size */
  }

  .SocialInput-module__fieldStacked__uSbJs {
    height: auto;
  }

  /* \`.mantine-TextInput-root\` is not matched here on purpose: it is the same
     element as \`.field\`, so a descendant selector would never reach it. */
  .SocialInput-module__field__Lv0Qi .mantine-TextInput-wrapper {
    width: 100%;
  }

  /* nw4applications spaces its form rows with a margin on every InputWrapper.
     The field here is half of a control, not a row: that margin enlarges the
     flex line and leaves the prefix stretching past the bottom of the input.
     \`.field\` is itself the InputWrapper root - a TextInput's className lands
     there - so this is a compound selector, not a descendant one, and its three
     classes win over that rule whatever the stylesheet order. */
  .SocialInput-module__wrapper__zJIHW .SocialInput-module__field__Lv0Qi.mantine-InputWrapper-root {
    margin-bottom: 0;
  }

  /* Target the input element itself */
  .SocialInput-module__field__Lv0Qi input {
    width: 100%;
  }

  .SocialInput-module__fieldStacked__uSbJs input {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    min-height: 42px !important;
  }
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/SocialInput/SocialInput.module.css"],"names":[],"mappings":"AAAA;;kFAEkF;;GAE/E;IACC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA,4BAA4B;EAC5B;IACE,wCAAwC;EAC1C;;EAEA;kDACgD;EAChD;IACE,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6CAA6C;IAC7C,6CAA6C;IAC7C,kBAAkB;IAClB,qDAAqD;IACrD,wDAAwD;IACxD,mBAAmB;IACnB;;gFAE4E;IAC5E,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mDAAmD;IACnD,mBAAmB;IACnB,sDAAsD;IACtD,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,yCAAyC;EACzC;IACE,6CAA6C;IAC7C,yCAAyC;EAC3C;;EAEA;;;;;;4DAM0D;EAC1D;IACE,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;EACjD;;EAEA;IACE,cAAc;IACd,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iDAAiD;IACjD,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,WAAW;IACX,YAAY,EAAE,iDAAiD;EACjE;;EAEA;IACE,YAAY;EACd;;EAEA;0EACwE;EACxE;IACE,WAAW;EACb;;EAEA;;;;;gEAK8D;EAC9D;IACE,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;EAC7B","sourcesContent":["/* =============================================================================\n   SOCIAL INPUT\n   ============================================================================= */\n\n   .container {\n    width: 100%;\n  }\n\n  .wrapper {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n    border-radius: var(--mantine-radius-default);\n    flex-wrap: nowrap;\n  }\n\n  .wrapperStacked {\n    flex-direction: column;\n    height: auto;\n  }\n\n  /* .wrapper--error .prefix */\n  .wrapperError .prefix {\n    border-color: var(--mantine-color-red-6);\n  }\n\n  /* Keep prefix border in sync with the input focus state.\n     &:focus-within:not(.wrapper--error) .prefix */\n  .wrapper:focus-within:not(.wrapperError) .prefix {\n    border-color: var(--mantine-color-dark-6);\n  }\n\n  .prefix {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 0 12px;\n    background-color: var(--mantine-color-gray-0);\n    border: 1px solid var(--mantine-color-gray-4);\n    border-right: none;\n    border-top-left-radius: var(--mantine-radius-default);\n    border-bottom-left-radius: var(--mantine-radius-default);\n    white-space: nowrap;\n    /* No height here: `align-items: stretch` on the wrapper only applies to an\n       item whose cross size is `auto`, so declaring one would opt the prefix\n       out of stretching and leave it at content height beside a taller field. */\n    transition: border-color 120ms ease;\n  }\n\n  .prefixStacked {\n    width: 100%;\n    min-height: 36px;\n    border-right: 1px solid var(--mantine-color-gray-4);\n    border-bottom: none;\n    border-top-right-radius: var(--mantine-radius-default);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  /* [data-mantine-color-scheme=\"dark\"] & */\n  :global([data-mantine-color-scheme=\"dark\"]) .prefix {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n  }\n\n  /* The prefix is a Box of its own, so it inherits nothing from the disabled\n     input beside it: same token, opacity and cursor Mantine gives its inputs.\n     Declared after the dark-scheme rule above, which has equal specificity and\n     would otherwise win on the background. No colour: the icon and the prefix\n     text set their own, so it would never be inherited. No border-color: the\n     opacity already fades the border like the input's, and it would collide\n     with `.wrapperError .prefix` at the same specificity. */\n  .wrapperDisabled .prefix {\n    cursor: not-allowed;\n    opacity: 0.6;\n    background-color: var(--mantine-color-disabled);\n  }\n\n  .icon {\n    flex-shrink: 0;\n    color: var(--mantine-color-gray-6);\n  }\n\n  .icon[data-social-image-icon='true'] {\n    opacity: 0.62;\n  }\n\n  :global([data-mantine-color-scheme=\"dark\"]) .icon {\n    color: var(--mantine-color-gray-5);\n  }\n\n  :global([data-mantine-color-scheme=\"dark\"]) .icon[data-social-image-icon='true'] {\n    opacity: 0.8;\n  }\n\n  .prefixText {\n    font-family: var(--mantine-font-family-monospace);\n    font-size: 0.813rem;\n    user-select: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .field {\n    flex: 1;\n    display: flex;\n    width: 100%;\n    min-width: 0; /* Allow flex item to shrink below content size */\n  }\n\n  .fieldStacked {\n    height: auto;\n  }\n\n  /* `.mantine-TextInput-root` is not matched here on purpose: it is the same\n     element as `.field`, so a descendant selector would never reach it. */\n  .field :global(.mantine-TextInput-wrapper) {\n    width: 100%;\n  }\n\n  /* nw4applications spaces its form rows with a margin on every InputWrapper.\n     The field here is half of a control, not a row: that margin enlarges the\n     flex line and leaves the prefix stretching past the bottom of the input.\n     `.field` is itself the InputWrapper root - a TextInput's className lands\n     there - so this is a compound selector, not a descendant one, and its three\n     classes win over that rule whatever the stylesheet order. */\n  .wrapper .field:global(.mantine-InputWrapper-root) {\n    margin-bottom: 0;\n  }\n\n  /* Target the input element itself */\n  .field input {\n    width: 100%;\n  }\n\n  .fieldStacked input {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    min-height: 42px !important;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SocialInput-module__container__RXG8k`,
	"wrapper": `SocialInput-module__wrapper__zJIHW`,
	"wrapperStacked": `SocialInput-module__wrapperStacked__EofyF`,
	"wrapperError": `SocialInput-module__wrapperError__eHYQU`,
	"prefix": `SocialInput-module__prefix__VxDEj`,
	"prefixStacked": `SocialInput-module__prefixStacked__v8sie`,
	"wrapperDisabled": `SocialInput-module__wrapperDisabled__l5WHj`,
	"icon": `SocialInput-module__icon__UlFkr`,
	"prefixText": `SocialInput-module__prefixText__pZ467`,
	"field": `SocialInput-module__field__Lv0Qi`,
	"fieldStacked": `SocialInput-module__fieldStacked__uSbJs`
};
module.exports = ___CSS_LOADER_EXPORT___;
